import React from 'react';
import PropTypes from 'prop-types';
import url from 'url';
import faker from 'faker';
import moment from 'moment';

import useBranch from 'client/hooks/useBranch';

import SrBox from 'client/components/SrBox';

const getFormValues = () => {
  return {
    moveInDate: moment().add(1, 'week').toISOString(),
    leaseTerm: 12,
    currentLandlordName: faker.name.findName(),
    currentLandlordEmail: 'devtesting+lanlord@sunroomrentals.com',
    currentLandlordPhone: '5125550001',
    currentMonthlyRent: '2000',
    currentRentalMoveInDate: moment().subtract(2, 'years').toISOString(),
    currentRentalMoveOutDate: moment().add(1, 'week').toISOString(),
    currentRentalReasonMovingOut: 'Relocating to Austin',
    employmentStatus: 'employed',
    payRentExplanation: '',
    currentJobCompany: 'Tesla',
    currentJobPosition: 'Industry Manager',
    currentJobEmployerMailingAddress: '863 W Fletcher St Chicago, IL 60657',
    currentJobSupervisorName: 'Lauren Baker',
    currentJobSupervisorPhoneNumber: '5125550001',
    currentJobEmployerEmail: 'devtesting+supervisor@sunroomrentals.com',
    currentJobStartDate: moment().subtract(2, 'years').toISOString(),
    previousJobCompany: '',
    previousJobMailingAddress: '',
    previousJobSupervisorName: '',
    previousJobSupervisorPhoneNumber: '',
    previousJobEmployerEmail: '',
    previousJobStartDate: '',
    previousJobEndDate: '',
    explanationOfIncome: '',
    paystubPhotos: [
      faker.random.image(),
      faker.random.image(),
      faker.random.image(),
    ],
    additionalProofOfIncomePhotosCount: 0,
    childrenCount: 0,
    vehicleCount: 1,
    vehicles: [
      {
        type: 'suv',
        model: 'Volkswagen Tiguan',
        color: 'Red',
        year: 2015,
        licensePlateNumber: '000000',
        licenseState: 'IL',
        monthlyPayment: '0',
      },
    ],
    petCount: 1,
    pets: [
      {
        name: 'Chao',
        type: 'dog',
        weight: '20',
        breed: 'Cavalier King Charles Spaniel',
        color: 'Black and Tan',
        age: '8',
        gender: 'female',
        neutered: true,
        declawed: false,
        rabiesShotsCurrent: true,
        isEsa: false,
        photo: faker.random.image(),
      },
    ],
    hasWaterFilledFurniture: false,
    renterInsurance: true,
    inMilitary: false,
    renterHasPreviouslyBeenEvicted: false,
    renterHasPreviouslyBreachedLeaseContract: false,
    renterPreviouslyAskedToMoveOut: false,
    renterPreviouslyFiledForBankruptcy: false,
    renterPrevioulsyLostPropertyForeclosure: false,
    renterPreviouslyHadCreditProblems: false,
    renterPreviouslyConvitedOfCrime: false,
    hasRegisteredSexOffenders: false,
    hasPendingCriminalMatters: false,
    agreeTermsOfService: true,
  };
};

const SrRentalApplicationFlowTestForm = ({
  formikBag,
}) => {
  const { appUrl } = useBranch({
    appUrl: ['env', 'APP_URL'],
  });

  const onClickButton = () => {
    const formValues = getFormValues();

    for (const formFieldId of Object.keys(formValues)) {
      formikBag.setFieldValue(formFieldId, formValues[formFieldId]);
    }
  };

  if (url.parse(appUrl).hostname === 'sunroomrentals.com') {
    return null;
  }

  return (
    <SrBox
      onClick={onClickButton}
      className='floatButton merge'
      left='30px'
      bottom='140px'
    />
  );
};

SrRentalApplicationFlowTestForm.propTypes = {
  formikBag: PropTypes.object.isRequired,
};

SrRentalApplicationFlowTestForm.displayName = 'SrRentalApplicationFlowTestForm';

export default SrRentalApplicationFlowTestForm;
